module.exports = __webpack_public_path__ + "static/media/category.fbda27ef.webp";